import { render, staticRenderFns } from "./FeMenuTree.vue?vue&type=template&id=6dee0b74&scoped=true&"
import script from "./FeMenuTree.vue?vue&type=script&lang=js&"
export * from "./FeMenuTree.vue?vue&type=script&lang=js&"
import style0 from "./FeMenuTree.vue?vue&type=style&index=0&id=6dee0b74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dee0b74",
  null
  
)

export default component.exports